function setNavMenuContainerHeightVar() {
  const navMenuContainer = document.querySelector('.main-nav-container menu');
  if (navMenuContainer) {
    const navMenuContainerHeight = navMenuContainer.offsetHeight;
    document.documentElement.style.setProperty('--nav-menu-container-height', navMenuContainerHeight + 'px');
  }
}

function setViewportHeightVar() {
  document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');
}

function handleNavWithChilds() {
  const navWithChilds = document.querySelectorAll('.has-childs');
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  
  navWithChilds.forEach(function(nav) {
    const navLinkParent = nav.parentElement;
    let closeTimeout;
    
    // Prevent default navigation on links with children
    nav.addEventListener('click', function(e) {
      e.preventDefault();
    });
    
    if (isMobile) {
      // Mobile: click to toggle
      nav.addEventListener('click', function(e) {
        navLinkParent.classList.toggle('show');
        const subMenuContainer = navLinkParent.querySelector('.sub-menu-container');
        const subMenuHeight = subMenuContainer.offsetHeight;
        const navMenuContainer = document.querySelector('.main-nav-container menu');
        navMenuContainer.classList.toggle('opened-sub-menu');
        document.documentElement.style.setProperty('--opened-sub-menu-height', subMenuHeight + 'px');
      });
    } else {
      // Desktop: hover with delay
      navLinkParent.addEventListener('mouseenter', function() {
        // Clear any pending close timeout
        if (closeTimeout) {
          clearTimeout(closeTimeout);
        }
        
        navLinkParent.classList.add('show');
        const subMenuContainer = navLinkParent.querySelector('.sub-menu-container');
        const subMenuHeight = subMenuContainer.offsetHeight;
        const navMenuContainer = document.querySelector('.main-nav-container menu');
        navMenuContainer.classList.add('opened-sub-menu');
        document.documentElement.style.setProperty('--opened-sub-menu-height', subMenuHeight + 'px');
      });
      
      navLinkParent.addEventListener('mouseleave', function() {
        // Add delay before closing to allow time to move to submenu
        closeTimeout = setTimeout(function() {
          navLinkParent.classList.remove('show');
          const navMenuContainer = document.querySelector('.main-nav-container menu');
          navMenuContainer.classList.remove('opened-sub-menu');
        }, 200); // 200ms delay
      });
    }
  });
}

function handleFadeOut() {
  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function () {
    $("body").removeClass("fade-out");
    setTimeout(function () {
    }, 250);
  }, false);
  setTimeout(function () {
    $("body").removeClass("fade-out");
  }, 500);
}

function handleBackToTopButton() {
  const backToTopButton = document.querySelector('.back-to-top-button');
  if (backToTopButton) {
    backToTopButton.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
}

function applyHoverColors() {
  const menusWithHoverColor = document.querySelectorAll('*[data-hover-color]');
  menusWithHoverColor.forEach(function(menu) {
    const hoverColor = menu.getAttribute('data-hover-color');
    if (hoverColor) {
      menu.style.setProperty('--hover-color', hoverColor);
      menu.style.setProperty('--hover-color-50', toAlphaColor(hoverColor, 0.5));
    }
  });
}

// Converts a CSS color string to a version with the given alpha when possible.
// Supports: hex (#rgb/#rgba/#rrggbb/#rrggbbaa), rgb/rgba, hsl/hsla.
// Falls back to color-mix for other formats (e.g., CSS variables).
function toAlphaColor(inputColor, alpha) {
  if (!inputColor) return '';
  const color = String(inputColor).trim();

  // HEX
  if (color[0] === '#') {
    const hex = color.slice(1);
    let r, g, b;
    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    } else if (hex.length === 4) { // #rgba → ignore original a
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    } else if (hex.length === 6 || hex.length === 8) {
      r = parseInt(hex.slice(0, 2), 16);
      g = parseInt(hex.slice(2, 4), 16);
      b = parseInt(hex.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }

  // rgb / rgba
  const rgbMatch = color.match(/^rgba?\(\s*([^,]+)\s*,\s*([^,]+)\s*,\s*([^,\)]+)\s*(?:,\s*([^\)]+)\s*)?\)$/i);
  if (rgbMatch) {
    const to255 = (v) => {
      const s = String(v).trim();
      if (s.endsWith('%')) return Math.round(parseFloat(s) * 2.55);
      return parseFloat(s);
    };
    const r = to255(rgbMatch[1]);
    const g = to255(rgbMatch[2]);
    const b = to255(rgbMatch[3]);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  // hsl / hsla
  const hslMatch = color.match(/^hsla?\(\s*([^,]+)\s*,\s*([^,]+)\s*,\s*([^,\)]+)\s*(?:,\s*([^\)]+)\s*)?\)$/i);
  if (hslMatch) {
    const h = hslMatch[1].trim();
    const s = hslMatch[2].trim();
    const l = hslMatch[3].trim();
    return `hsla(${h}, ${s}, ${l}, ${alpha})`;
  }

  // Fallback that works with CSS variables and named colors
  // Mix 30% of the color with transparent to simulate alpha
  const pct = Math.round(alpha * 100);
  return `color-mix(in srgb, ${color} ${pct}%, transparent)`;
}

function setFullscreenSwipers() {
  const fullscreenSwipers = document.querySelectorAll('.module-fullscreen-swiper');
  const isMobile = window.innerWidth < 768;

  fullscreenSwipers.forEach(function(swiper, index) {
    index = index + 1;

    const newSwiperClass = `fullscreen-swiper-${index}`;
    const newPaginationClass = `fullscreen-swiper-pagination-${index}`;

    swiper.classList.add(newSwiperClass);

    // Crear contenedor de paginación si no existe
    const paginationEl = document.createElement('div');
    paginationEl.classList.add(newPaginationClass, 'swiper-pagination');
    swiper.appendChild(paginationEl);

    const swiperInstance = new Swiper(`.${newSwiperClass}`, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
      keyboard: true,
      pagination: {
        el: `.${newPaginationClass}`,
        clickable: true,
      },
      autoplay: isMobile ? {
        delay: 3000,
        disableOnInteraction: true,
      } : false,
    });
  });
}

function setMultiMediaSwipers() {
  const multiMediaSwipers = document.querySelectorAll('.module-multi-media-swiper');
  const isMobile = window.innerWidth < 768;
  
  multiMediaSwipers.forEach(function(swiper, index) {
    const slides = swiper.querySelectorAll('.swiper-slide'); // todas las slides
    const columns = swiper.getAttribute('data-columns') || 2;
    index = index + 1;
    const newSwiperClass = `multi-media-swiper-${index}`;
    swiper.classList.add(newSwiperClass);
    // Si hay 3 o menos slides, desactivar loop y mousewheel
    const shouldLoop = slides.length > 3;

    new Swiper(`.${newSwiperClass}`, {
      loop: shouldLoop,
      slidesPerView: 1,
      spaceBetween: 0,
      mousewheel: shouldLoop ? {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      } : false,
      keyboard: true,
      autoplay: isMobile ? {
        delay: 4000,
        disableOnInteraction: true,
      } : false,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: columns,
        }
      }
    });
  });
}

function ensureScrollClassesCleanup() {
  // Clean up any stuck overflow classes on page load
  document.documentElement.classList.remove('minicart-open');
  document.body.classList.remove('dialog-open');
  
  // Also clean up on page visibility change (when user switches tabs and comes back)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      document.documentElement.classList.remove('minicart-open');
      document.body.classList.remove('dialog-open');
    }
  });
  
  // Clean up on page unload
  window.addEventListener('beforeunload', function() {
    document.documentElement.classList.remove('minicart-open');
    document.body.classList.remove('dialog-open');
  });
}

$(document).ready(function() {
  
  handleNavWithChilds();
  setNavMenuContainerHeightVar();
  setViewportHeightVar();
  handleFadeOut();
  handleBackToTopButton();
  applyHoverColors();
  setFullscreenSwipers();
  setMultiMediaSwipers();
  ensureScrollClassesCleanup();

  let lastWidth = window.innerWidth;
  window.addEventListener('resize', function() {
    const currentWidth = window.innerWidth;
    // Only recalculate nav height on actual width changes (not mobile browser UI changes)
    if (currentWidth !== lastWidth) {
      setNavMenuContainerHeightVar();
      lastWidth = currentWidth;
    }
    setViewportHeightVar();
  });

  document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector("form-embed#app-embed-container-785137");

  if (el && el.shadowRoot) {
    const style = document.createElement("style");
    style.textContent = `
      /* tus estilos */
    `;
    el.shadowRoot.appendChild(style);
  }
});
});